(() => {
  const SELECTOR = 'variant-selects[data-high-variants="true"]';

  const getRoot = () => document.querySelector(SELECTOR);

  const getSelectedOptionValueIds = (root) => {
    const selects = root.querySelectorAll('select.select__select');

    if (selects.length) {
      return Array.from(selects)
        .map((sel) => sel.selectedOptions?.[0]?.dataset?.optionValueId)
        .filter(Boolean);
    }

    const checked = root.querySelectorAll(
      'input[type="radio"][data-option-value-id]:checked'
    );

    return Array.from(checked)
      .map((el) => el.dataset.optionValueId)
      .filter(Boolean);
  };

  const updateBrowserUrlFromDoc = (doc) => {
    const variantInput = doc.querySelector('[data-product-variant-id]');
    const variantId = variantInput?.value;

    if (!variantId) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  };

  const bindHighVariants = () => {
    const root = getRoot();
    if (!root || root.dataset.highVariantsBound === 'true') return;

    root.dataset.highVariantsBound = 'true';

    root.addEventListener('change', async () => {
      const currentRoot = getRoot();
      if (!currentRoot) return;

      const sectionId =
        currentRoot.dataset.section || currentRoot.getAttribute('data-section');
      const url = currentRoot.dataset.url || currentRoot.getAttribute('data-url');

      if (!sectionId || !url) return;

      const ids = getSelectedOptionValueIds(currentRoot);
      if (!ids.length) return;

      const params = new URLSearchParams();
      params.set('section_id', sectionId);
      params.set('option_values', ids.join(','));

      const res = await fetch(`${url}?${params.toString()}`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!res.ok) return;

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const fresh = doc.querySelector(`[data-section-id="${sectionId}"]`);
      const current = document.querySelector(`[data-section-id="${sectionId}"]`);

      if (!fresh || !current) return;

      current.replaceWith(fresh);

      updateBrowserUrlFromDoc(doc);
      bindHighVariants();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindHighVariants);
  } else {
    bindHighVariants();
  }
})();